export const config = {
  apiKey: "AIzaSyByVKQeTGTrkKNb7Q5HrNrYbz1x77",
  authDomain: "crypt-web.firebaseapp.com",
  databaseURL: "https://crypt-web.firebaseio.com",
  projectId: "crypt-web",
  storageBucket: "crypt-web.appspot.com",
  messagingSenderId: "181722344430"
};
